import { useGetApplication } from 'app/hooks';
import { type ResponseValues } from 'axios-hooks';

import type Paginated from '../../../core/paginable';

import { baseUrl } from './http';
import { type FormStatement } from './types';

export const useFormStatement: (id: string) => ResponseValues<FormStatement, any, any> = (
  id: string
) => {
  const [{ data, loading, error, response }] = useGetApplication<Paginated<FormStatement>>({
    url: baseUrl,
    params: {
      id,
      page: 1,
      pageSize: 1
    }
  });

  const [form] = data?.data || [];

  return { loading, data: form, error, response } as any;
};

export const useGetAllFormStatement: (
  loadMode?: boolean
) => ResponseValues<Array<FormStatement>, any, any> = (loadMode = true) => {
  const [{ data, loading, error, response }] = useGetApplication<Array<FormStatement>>(
    {
      url: `${baseUrl}/all`,
      params: undefined
    },
    loadMode
  );

  return { loading, data: data, error, response };
};
